// plugins/head.ts
export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig()
  return useHead({
    link: [
      { rel: 'icon', type: 'image/svg+xml', href: `${config.app.cdnURL}/favicon.svg` },
    ],
  })
})
